import { render, staticRenderFns } from "./InstitutionView.vue?vue&type=template&id=3af8b27d&"
import script from "./InstitutionView.vue?vue&type=script&lang=js&"
export * from "./InstitutionView.vue?vue&type=script&lang=js&"
import style0 from "./InstitutionView.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports